export { default as ServiceAreasStructuredData } from './structured-data';
